import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

function GirisSonrasiYonlendirme() {
  const navigate = useNavigate();

  useEffect(() => {
    const yonlendir = async () => {
      const user = auth.currentUser;

      if (!user) {
        navigate("/giris-yap");
        return;
      }

      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (userDoc.exists()) {
        const data = userDoc.data();
        const accountType = data?.userData?.defaultAccountType;

        switch (accountType) {
          case "öğrenci":
            navigate("/ogrenci-ekrani");
            break;
          case "öğretmen":
            navigate("/ogretmen-ekrani");
            break;
          case "veli":
            navigate("/veli-ekrani");
            break;
          default:
            navigate("/");
        }
      } else {
        navigate("/");
      }
    };

    yonlendir();
  }, [navigate]);

  return <div>Yönlendiriliyor...</div>;
}

export default GirisSonrasiYonlendirme;
